import { MapPin, Phone, Mail, Facebook, Twitter, Instagram, Linkedin, ExternalLink, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer id="contact" className="bg-black text-white/80 pt-20 pb-8 relative">
      <div className="livery-stripe absolute top-0 left-0 right-0" />

      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          <div className="lg:col-span-1 md:col-span-2">
            <div className="flex items-center mb-6">
              <img
                src="/Final_logo_6.png"
                alt="Moreflex Aviation"
                className="h-12 mr-2"
                loading="lazy"
              />
            </div>
            <p className="mb-6 text-sm leading-relaxed text-white/60">
              We provide premium airport services designed to make your travel experience seamless,
              comfortable, and stress-free.
            </p>
            <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[#73BDF2] mb-6">
              <ShieldCheck size={16} />
              IATA &amp; ICAO Aligned Standards
            </div>
            <div className="flex space-x-3">
              <a
                href="https://facebook.com/yourpage"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/5 border border-white/10 w-10 h-10 rounded-full flex items-center justify-center hover:bg-[#73BDF2] hover:border-[#73BDF2] transition-colors duration-300 social-icon"
                aria-label="Follow us on Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://twitter.com/yourpage"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/5 border border-white/10 w-10 h-10 rounded-full flex items-center justify-center hover:bg-[#73BDF2] hover:border-[#73BDF2] transition-colors duration-300 social-icon"
                aria-label="Follow us on Twitter"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://instagram.com/yourpage"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/5 border border-white/10 w-10 h-10 rounded-full flex items-center justify-center hover:bg-[#73BDF2] hover:border-[#73BDF2] transition-colors duration-300 social-icon"
                aria-label="Follow us on Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://linkedin.com/company/yourpage"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/5 border border-white/10 w-10 h-10 rounded-full flex items-center justify-center hover:bg-[#73BDF2] hover:border-[#73BDF2] transition-colors duration-300 social-icon"
                aria-label="Connect with us on LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold uppercase tracking-widest text-white mb-6">Main Pages</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#73BDF2] transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/partners" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Partners & Affiliations
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold uppercase tracking-widest text-white mb-6">Our Services</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/services#meet-greet" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Meet and Greet
                </Link>
              </li>
              <li>
                <Link to="/services#lounge" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Lounge Services
                </Link>
              </li>
              <li>
                <Link to="/services#chauffeur" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Fleet & Chauffeur
                </Link>
              </li>
              <li>
                <Link to="/services#baggage" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Baggage Assistance
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold uppercase tracking-widest text-white mb-6">Travel Resources</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/resources" className="hover:text-[#73BDF2] transition-colors duration-300">
                  Industry Resources & Links
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-[#73BDF2] transition-colors duration-300">
                  FAQ
                </Link>
              </li>
              <li>
                <a
                  href="https://www.iata.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#73BDF2] transition-colors duration-300 flex items-center"
                >
                  IATA <ExternalLink size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.icao.int/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#73BDF2] transition-colors duration-300 flex items-center"
                >
                  ICAO <ExternalLink size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.iata.org/en/publications/directories/code-search/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#73BDF2] transition-colors duration-300 flex items-center text-sm"
                >
                  Airport Codes <ExternalLink size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <Link to="/sitemap" className="hover:text-[#73BDF2] transition-colors duration-300">
                  HTML Sitemap
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold uppercase tracking-widest text-white mb-6">Contact</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start">
                <MapPin className="text-[#73BDF2] mr-3 mt-1 flex-shrink-0" size={18} />
                <span>80100 Mombasa, Kenya</span>
              </li>
              <li className="flex items-center">
                  <Phone
                    className="text-[#73BDF2] mr-3 flex-shrink-0"
                    size={18} />
                  <div className="flex flex-col">
                  <span>+254 (114) 660-056</span>
                  <span>+254 (102) 188-352</span>
                  </div>
                </li>
              <li className="flex items-center">
                <Mail className="text-[#73BDF2] mr-3 flex-shrink-0" size={18} />
                <span>info@moreflexaviation.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-white/50">
            <p>&copy; 2025 Moreflex Aviation Support Services. All Rights Reserved.</p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              <a href="#" className="hover:text-[#73BDF2] transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-[#73BDF2] transition-colors duration-300">
                Terms & Conditions
              </a>
              <Link to="/sitemap" className="hover:text-[#73BDF2] transition-colors duration-300">
                Sitemap
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
